<template>
  <v-container fluid>
    <v-container fluid class="app-container">
      <template v-if="ready && hasAcesso">
        <v-row class="ml-2 mt-5 text-center">
          <v-col cols="12">
            <p>
              <v-icon size="100" color="success">
                mdi-checkbox-marked-circle-outline
              </v-icon>
            </p>
            <p>Verificamos que sua empresa já está cadastrada e possui um usuário de acesso.</p>
            <p>
              Caso tenha alguma dúvida ou precise de suporte, entre em contato através do e-mail
              <b> suporte@proxpect.com.br</b> ou pelo contato <b>(48) 99144-6585</b>.
            </p>
          </v-col>
        </v-row>
      </template>
      <template v-if="ready && !hasAcesso">
        <div class="text-center mt-5">
          <v-row align="center" justify="center">
            <img class="logo" src="../../../assets/logo-azul-sem-fundo.png"
                 alt="Logo da Proxpect"/>
            <h1 class="blue--text text--darken-3">PROXPECT</h1>
          </v-row>
          <p>
            Verificamos que você já possui sua empresa cadastrada mas não possui um usuário de
            acesso à plataforma.
          </p>
          <p>
            Clique no botão abaixo para solicitar seu usuário.
          </p>
          <div class="mt-5 mb-5">
            <v-btn color="primary" :loading="loadingButton" @click="solicitarUsuario">
              Solicitar usuário
            </v-btn>
          </div>
          <p class="mt-3">
            Você receberá um e-mail no endereço <b>{{ acesso.fornecedor.email }}</b>
            com as instruçoes para criação do usuário.
          </p>
          <p>
            Caso tenha alguma dúvida ou precise de suporte, entre em contato através do e-mail
            <b> suporte@proxpect.com.br</b> ou pelo contato <b>(48) 99144-6585</b>.
          </p>
        </div>
      </template>
    </v-container>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import FornecedorService from '../fornecedor-service';

export default {
  data() {
    return {
      loading: false,
      loadingButton: false,
      acesso: null,
      ready: false,
    };
  },
  computed: {
    ...mapGetters('criarConta', ['rawCnpj', 'cnpj']),
    hasAcesso() {
      return this.acesso && this.acesso.acesso;
    },
  },
  methods: {
    validaAcesso() {
      this.loading = true;
      FornecedorService.acesso(this.rawCnpj)
        .then((response) => {
          this.acesso = response.data;
        })
        .finally(() => {
          this.ready = true;
          this.loading = false;
        });
    },
    solicitarUsuario() {
      this.loadingButton = true;
      FornecedorService.solicitarUser(this.acesso.fornecedor.id)
        .then(() => {
          this.$toast('Sua solicitação foi enviada com sucesso, verifique seu e-mail em alguns minutos', { color: 'success' });
          return this.$router.push({ name: 'login' });
        })
        .finally(() => {
          this.loadingButton = false;
        });
    },
  },
  created() {
    if (!this.rawCnpj) {
      this.$router.push({ name: 'criar-conta' });
      return;
    }
    this.validaAcesso();
  },
};
</script>

<style scoped>
  .logo {
    max-width: 80px;
  }
</style>
